import { render, staticRenderFns } from "./LenderList.vue?vue&type=template&id=bc2829fe&"
import script from "./LenderList.vue?vue&type=script&lang=js&"
export * from "./LenderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports